import styled from "styled-components";
import Card from "@material-ui/core/Card";

export const CustomCard = styled(Card)(({ color }) => ({
  backgroundColor: color,
  borderRadius: "5px",
  display: "flex",
  flexDirection: "column",
  alignItems: "left",
  width: "100%",
  fontWeight: "bold",
  height: "250.34px",
  transition: "box-shadow 0.3s ease, transform 0.3s ease", // smooth transition
  boxShadow: "0 1px 3px rgba(0,0,0,0.1)",

  "@media (max-width: 1600px)": {
    height: "220px",
  },

  "@media (max-width: 1800px)": {
    height: "210px",
  },

  "&:hover": {
    boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
    transform: "translateY(-2px)", // optional: subtle lift on hover
    cursor: "pointer",
  },
}));